import { render, staticRenderFns } from "./ModernizacaoSistemasItajai.vue?vue&type=template&id=7e65a2f9&scoped=true"
import script from "./ModernizacaoSistemasItajai.vue?vue&type=script&lang=js"
export * from "./ModernizacaoSistemasItajai.vue?vue&type=script&lang=js"
import style0 from "./ModernizacaoSistemasItajai.vue?vue&type=style&index=0&id=7e65a2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65a2f9",
  null
  
)

export default component.exports